import RespondentsConsumerAllWarrantyPanel from './respondentsConsumerAllWarrantyPanel.container'

export default RespondentsConsumerAllWarrantyPanel;